<template>
  <view-layout v-bind="$attrs" footer-color="transparent" footer-class="text-left">
    <template v-if="$slots.title" slot="title">
      <text-h3 class="mt-3" style="width: 100%">
        <slot name="title" />
      </text-h3>
    </template>

    <v-card v-if="!!$slots.subtitle" flat dark tile class="text-left px-4 pb-4 pt-2" :style="$attrs['body-style']" color="primary">
      <slot name="subtitle"></slot>
    </v-card>
    <v-card light flat tile class="d-flex flex-column text-center rounded-t-lg mt-n4 " color="white" style="width: 100%;">
      <slot></slot>
    </v-card>

    <!--footer-->
    <template slot="footer">
      <v-row v-if="!!$slots.footer || !!$slots['footer-left'] || !!$slots['footer-right']" no-gutters align="center" class="pa-4" style="background-color: rgb(255, 255, 255)">

        <!--footer: alinha ao centro - usado sozinho-->
        <v-col v-if="!!$slots.footer" cols="12"><slot name="footer"></slot></v-col>

        <!--footer-left: alinha esquerda-->
        <v-col v-if="!$slots.footer" cols="auto" class="mr-auto">
          <slot name="footer-left"></slot>
        </v-col>

        <!--footer-right: alinha direita-->
        <v-col v-if="!$slots.footer" cols="auto">
          <slot name="footer-right"></slot>
        </v-col>
      </v-row>
    </template>
  </view-layout>
</template>

<script>
export default {
  data () {
    return {
      model: {},
    }
  }
};
</script>
